import React from 'react';
import {
  Download,
  Maximize2,
  Sparkles,
  Scissors,
  Scan,
  Tag,
  Lightbulb,
  Split,
  Grid3x3,
  Layers,
  Grid2x2,
} from 'lucide-react';
import { ButtonItem } from './DropdownMenu';

const HDIcon: React.FC<{ size?: number; className?: string }> = ({ size = 18, className }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <rect x="3" y="3" width="18" height="18" rx="1" stroke="currentColor" strokeWidth="1.8" />
    <text x="12" y="15" textAnchor="middle" fill="currentColor" fontSize="8" fontWeight="700" fontFamily="system-ui, sans-serif">HD</text>
  </svg>
);

export type { ButtonItem };

export function getImageButtons(handlers: {
  onPanorama: (e: React.MouseEvent) => void;
  onMultiAngle: (e: React.MouseEvent) => void;
  onLighting: (e: React.MouseEvent) => void;
  onDownload: (e: React.MouseEvent) => void;
  mediaUrl?: string;
  mediaType?: string;
}): ButtonItem[] {
  return [
    { id: 'panorama', label: '全景', icon: Grid2x2, isPlaceholder: false, show: true, title: '全景', onClick: handlers.onPanorama },
    { id: 'multi-angle', label: '多角度', icon: Layers, isPlaceholder: false, show: true, title: '多角度', onClick: handlers.onMultiAngle },
    { id: 'lighting', label: '打光', icon: Lightbulb, isPlaceholder: false, show: true, title: '打光', onClick: handlers.onLighting },
    { id: 'grid', label: '九宫格', icon: Grid3x3, isPlaceholder: true, show: true, title: '九宫格', hasDropdown: true },
    { id: 'upscale', label: '工具', icon: Sparkles, isPlaceholder: true, show: true, title: '工具', hasDropdown: true },
    { id: 'split', label: '宫格切分', icon: Split, isPlaceholder: true, show: true, title: '宫格切分', hasDropdown: true },
    { id: 'annotate', label: '标注', icon: Tag, isPlaceholder: false, show: true, title: '标注' },
    { id: 'fullscreen', icon: Maximize2, isPlaceholder: true, show: handlers.mediaType !== 'audio', title: '全屏预览' },
    { id: 'download', icon: Download, show: !!handlers.mediaUrl, onClick: handlers.onDownload, title: '下载' },
  ];
}

export function getVideoButtons(handlers: {
  onDownload: (e: React.MouseEvent) => void;
  mediaUrl?: string;
  mediaType?: string;
}): ButtonItem[] {
  return [
    { id: 'edit', label: '剪辑', icon: Scissors, isPlaceholder: true, show: true, title: '剪辑' },
    { id: 'upscale', label: '高清', icon: HDIcon, isPlaceholder: true, show: true, title: '高清' },
    { id: 'analyze', label: '解析', icon: Scan, isPlaceholder: true, show: true, title: '解析' },
    { id: 'fullscreen', icon: Maximize2, isPlaceholder: true, show: handlers.mediaType !== 'audio', title: '全屏预览' },
    { id: 'download', icon: Download, show: !!handlers.mediaUrl, onClick: handlers.onDownload, title: '下载' },
  ];
}

export function getCommonButtons(handlers: {
  onDownload: (e: React.MouseEvent) => void;
  mediaUrl?: string;
  mediaType?: string;
}): ButtonItem[] {
  return [
    { id: 'fullscreen', icon: Maximize2, isPlaceholder: true, show: handlers.mediaType !== 'audio', title: '全屏预览' },
    { id: 'download', icon: Download, show: !!handlers.mediaUrl, onClick: handlers.onDownload, title: '下载' },
  ];
}
